import React from 'react';
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableContainer
} from '@mui/material';
import FormRow from './FormRow';

const WeightAndFuelTab = ({ formData, handleChange }) => {
  return (
    <Box>
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{
          mb: 3,
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
        }}
      >
        <Box 
          sx={{ 
            p: 1.5, 
            bgcolor: 'primary.main', 
            color: 'white',
            borderRadius: '8px 8px 0 0'
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Weight Specifications</Typography>
        </Box>
        <Table size="small" sx={{ '& .MuiTableCell-root': { borderColor: 'rgba(0, 0, 0, 0.08)' } }}>
          <TableBody>
            <FormRow label="Weight Unit" required>
              <TextField
                fullWidth
                size="small"
                select
                value={formData.weightUnit}
                onChange={handleChange('weightUnit')}
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              >
                <MenuItem value="kg">Kilogram (kg)</MenuItem>
                <MenuItem value="lb">Pound (lb)</MenuItem>
              </TextField>
            </FormRow>
            <FormRow label="Basic Empty Weight" required>
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.basicEmptyWeight}
                onChange={handleChange('basicEmptyWeight')}
                helperText="Weight when aircraft's fuel is empty, no passengers or crew onboarded and no luggage"
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              />
            </FormRow>
            <FormRow label="Max All-Up Weight">
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.maxAllUpWeight}
                onChange={handleChange('maxAllUpWeight')}
                helperText="Maximum permitted weight when aircraft does a take-off from ground"
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              />
            </FormRow>
            <FormRow label="Max Ramp Weight">
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.maxRampWeight}
                onChange={handleChange('maxRampWeight')}
                helperText="Maximum permitted weight prior to take-off"
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              />
            </FormRow>
            <FormRow label="Max Landing Weight">
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.maxLandingWeight}
                onChange={handleChange('maxLandingWeight')}
                helperText="Maximum weight permitted at the time of landing"
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              />
            </FormRow>
            <FormRow label="Max Fuel Weight">
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.maxFuelWeight}
                onChange={handleChange('maxFuelWeight')}
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              />
            </FormRow>
            <FormRow label="Fuel Weight Unit Metric">
              <TextField
                fullWidth
                size="small"
                select
                value={formData.weightUnit}
                onChange={handleChange('weightUnit')}
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              >
                <MenuItem value="kg">kg (Kilogram)</MenuItem>
                <MenuItem value="lb">lbs (Pound)</MenuItem>
              </TextField>
            </FormRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer 
        component={Paper} 
        variant="outlined" 
        sx={{ 
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
        }}
      >
        <Box 
          sx={{ 
            p: 1.5, 
            bgcolor: 'primary.main', 
            color: 'white',
            borderRadius: '8px 8px 0 0'
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Fuel Specifications</Typography>
        </Box>
        <Table size="small" sx={{ '& .MuiTableCell-root': { borderColor: 'rgba(0, 0, 0, 0.08)' } }}>
          <TableBody>
            <FormRow label="Fuel Capacity Volume (Liters)">
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.fuelCapacity}
                onChange={handleChange('fuelCapacity')}
                helperText="Always in Litres (L)"
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              />
            </FormRow>
            <FormRow label="Fuel Consumption per hour">
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.fuelConsumptionPerHour}
                onChange={handleChange('fuelConsumptionPerHour')}
                helperText="Fuel consumption of the aircraft per every hour"
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              />
            </FormRow>
            <FormRow label="Fuel Consumption per hour (Weight)">
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.fuelConsumptionPerHourWeight}
                onChange={handleChange('fuelConsumptionPerHourWeight')}
                helperText="Fuel consumption of the aircraft per every hour (weight), using the Fuel Weight Unit Metric"
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              />
            </FormRow>
            <FormRow label="Fuel Volume Unit Metric">
              <TextField
                fullWidth
                size="small"
                select
                value={formData.fuelConsumptionPerHourUnit}
                onChange={handleChange('fuelConsumptionPerHourUnit')}
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              >
                <MenuItem value="L">L (Liter)</MenuItem>
                <MenuItem value="gal">gal (Gallon)</MenuItem>
              </TextField>
            </FormRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default WeightAndFuelTab;

